























import { computed, defineComponent } from "@vue/composition-api";

export default defineComponent({
  props: {
    disabled: Boolean,
    color: {
      default: "primary",
      type: String
    },
    background: String,
    width: {
      type: Number,
      default: 500
    },
    dark: {
      default: true,
      type: Boolean
    },
    padding: {
      default: true,
      type: Boolean
    }
  },
  setup(props) {
    const maxWidth = computed(() => {
      return isNaN(props.width) ? props.width + "" : props.width + "px";
    });

    const style = computed(() => {
      if (props.background) return `background: ${props.background} !important`;
      else return "";
    });

    return {
      maxWidth,
      style
    };
  }
});
